module.exports = __webpack_public_path__ + "static/media/left_drive.1db15949.png";